import BrndImg from "../../assets/imgs/brand.svg";
import React from "react"
import { Visible } from "react-awesome-styled-grid";

type Props = {
  partnerImageUrl: string,
  bankImageUrl: string,
  whiteLabel: Boolean,
}

const Footer = (props: Props) => {
  return (
    <Visible xs sm >
      <div className="px-1 px-md-4 my-2">
        {
          props.bankImageUrl && (
            <div className="mb-2" >
              <img src={props.bankImageUrl} style={{ paddingBottom: "8px", width: "125px" }} alt="" />
            </div>
          )
        }
        {
          (props.whiteLabel === true) ? ''  : (
            <div className="container-fluid text-muted px-0">
              <a href="https://www.swirepay.com" target="_blank" >
                <img src={BrndImg} className="pr-2" style={{ paddingBottom: "8px", width: "125px" }} alt="" />
              </a>
            </div>
          )
        }
      </div>
    </Visible>
  )
};

export default Footer;
